module.exports = __webpack_public_path__ + "static/media/galerija_2014 (7).62ade4dc.jpg";